import { createInertiaApp } from '@inertiajs/react'
import './application.css'

createInertiaApp({
  pages: '../pages',
  strictMode: true,
})
